export const format = (value: Number, decimal: any, section: Number) => {

    if(!value){
      return ''
    }
    var re = '\\d(?=(\\d{' + (section || 3) + '})+' + (decimal > 0 ? '\\.' : '$') + ')'
    return value.toFixed(Math.max(0, ~~decimal)).replace(new RegExp(re, 'g'), '$&,')
}

export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const sumArray = (array: Array<number>) => {
  return array?.reduce((_a: any, _b: any) => _a + _b, 0) || 0;
}

export const IS_EVISION_VENDOR = process.env.REACT_APP_VENDOR === 'evision';

export const switchName = (type: string) => {
  switch (type) {
    case 'date':
      return 'ngày';
    case 'week':
      return 'tuần';
    case 'month':
      return 'tháng';
    case 'quarter':
      return 'quý';
    case 'year':
      return 'năm';
  }
}